<template>
  <label
    class="def-input-mask"
    :class="{
      'def-input-mask_invalid': !isValid || isShowError,
    }"
  >
    <span
      class="def-input-mask__placeholder"
      :class="{ 'def-input-mask__placeholder_center': !saveValue && !isFocus }"
    >
      {{ placeholder }}
    </span>

    <input
      :id="id"
      ref="input"
      :type="type"
      :name="name"
      :required="required"
      :value="saveValue"
      :autocomplete="autocomplete"
      :form="form"
      :readonly="readonly"
      :pattern="pattern"
      class="def-input-mask__input"
      @input="handlerInput"
      @click="$emit('click', $event)"
      @keypress="$emit('keypress', $event)"
      @keydown="$emit('keydown', $event)"
      @keyup="$emit('keyup', $event)"
      @invalid.prevent="handlerInvalid"
      @blur="handlerBlur"
      @focus="handlerFocus"
    />
    <!--    <transition name="fade">-->
    <!--      <svg v-if="!isValid || isError" class="def-input-mask__icon-error">-->
    <!--        <use xlink:href="#svg-error-icon"></use>-->
    <!--      </svg>-->
    <!--    </transition>-->
    <!--    <transition name="fade">-->
    <!--      <svg v-if="isSuccess" class="def-input-mask__icon-success">-->
    <!--        <use xlink:href="#svg-circle-check"></use>-->
    <!--      </svg>-->
    <!--    </transition>-->
    <transition name="fade">
      <span v-if="!isValid || isShowError" class="def-input-mask__error">
        <slot />
      </span>
    </transition>
  </label>
</template>

<script>
const importInputmask = () => import(/* webpackChunkName: 'Inputmask' */ 'inputmask');
const options = {
  root: null,
  rootMargin: '100px',
  threshold: 1,
};

export default {
  name: 'DefInputMask',
  props: {
    name: String,
    placeholder: String,
    required: Boolean,
    autocomplete: Boolean,
    value: {
      type: String,
      default: '',
    },
    modelValue: {
      type: String,
      default: '',
    },
    id: String,
    form: String,
    type: {
      type: String,
      default: 'text',
    },
    isShowError: {
      type: Boolean,
      default: false,
    },
    isSuccess: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    pattern: {
      type: [String, null],
      default: null,
    },
    inputMaskSettings: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      isValid: true,
      isFocus: false,
      saveValue: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.saveValue = newValue;
    },
    modelValue(newValue) {
      this.saveValue = newValue;
    },
  },
  mounted() {
    if (this.inputMaskSettings) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(async (entry) => {
          if (entry.isIntersecting) {
            const { target } = entry;
            observer.unobserve(target);
            const Inputmask = await importInputmask();

            this.phoneMask = new Inputmask.default({
              // mask: '~{6}',
              showMaskOnHover: false,
              // definitions: {
              //   '~': {
              //     validator: '[0-9]',
              //     cardinality: 1,
              //     casing: 'lower',
              //   },
              // },
              placeholder: 'X',
              onincomplete: () => {
                this.isValid = false;
                this.$emit('onincomplete');
              },
              oncomplete: () => {
                this.isValid = true;
                this.$emit('oncomplete');
              },
              ...this.inputMaskSettings,
            });

            this.phoneMask.mask(this.$refs.input);
          }
        });
      }, options);

      observer.observe(this.$el);
    }
  },
  methods: {
    handlerInput(e) {
      this.saveValue = e.target.value;
      this.$emit('update:modelValue', this.saveValue);
    },
    handlerInvalid(e) {
      if (this.required) {
        this.isValid = false;
      }

      this.$emit('invalid', e);
    },
    handlerBlur(e) {
      const { target } = e;
      this.isFocus = false;
      this.$emit('blur', e);
    },
    handlerFocus(e) {
      this.isFocus = true;
      this.$emit('focus', e);
    },
  },
};
</script>

<style lang="scss" scoped>
.def-input-mask {
  display: flex;
  align-items: flex-end;
  position: relative;
  height: 52px;
  padding: 8px 16px;
  border: 1px solid #c8c8c8;
  margin-bottom: 16px;
  &__placeholder {
    position: absolute;
    top: 8px;
    color: var(--color-dark-grey);
    transition: 0.2s linear top;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
    overflow: hidden;
    font-size: 14px;
    font-weight: 500;
    &_center {
      font-size: rem(16);
      top: 16px;
    }
  }
  &__input {
    font-weight: 500;
    font-size: rem(16);
    border: none;
    height: 20px;
    transition: 0.2s linear border-bottom-color;
    //padding: 6px 20px 0 0;
    width: 100%;
  }
  &__error {
    position: absolute;
    left: 16px;
    top: calc(100% + 4px);
    font-size: rem(10);
    line-height: 100%;
    color: var(--color-red);
  }
  &_invalid {
    border-color: var(--background-red);
  }
  //&__icon-error {
  //  position: absolute;
  //  top: 13px;
  //  right: 0;
  //  fill: var(--background-red);
  //  width: 16px;
  //  height: 16px;
  //}
  //&__icon-success {
  //  position: absolute;
  //  top: 13px;
  //  right: 0;
  //  width: 16px;
  //  height: 16px;
  //}
}
</style>
